export default __webpack_public_path__ + "static/media/15.a06eb4d8.jpg";